import { useLanguageStore } from '$/store/languageStore';

/** 创建面板和首页入口复用正式 Smartcat，尚未确认的字段保留已有原文兜底。 */
export function useMyIpCreationCopy() {
  const language = useLanguageStore((state) => state.languageStore);
  /** 仅空译文回落已有源文案，不生成临时译文或改写语言包。 */
  const text = (key: string, fallback = '') => language.smartcatTranslationText((value) => value[key]) || fallback;
  return {
    panel: {
      identity: text('robo_character_identity', '角色身份'),
      personality: text('robo_character_traits', '性格特点'),
      appearance: text('robo_character_appearance', '外形特征'),
      speech_style: text('robo_character_speech_style', '语言风格'),
      backstory: text('robo_character_story', '角色故事'),
      main_visual: text('RoboNeo_Web_ip_creation_mainVisual', '角色IP主视觉'),
      materials: text('robo_ip_more_assets', '更多素材'),
      basic: text('robo_basic_settings', '基础设定'),
      basicCompact: text('RoboNeo_Web_ip_creation_basicCompact', '基础'),
      basicImage: text('RoboNeo_Web_ip_creation_basicImage', '基础形象'),
      characterStory: text('robo_character_story', '角色故事'),
      saveToLibrary: text('robo_save_to_my_ip', '保存到我的角色IP'),
      saveInfo: text('robo_save_info', '保存信息'),
      required: text('RoboNeo_Web_ip_creation_required', '请填写必填信息'),
      invalidImage: text('RoboNeo_Web_ip_creation_invalidImage', '请选择图片文件'),
      noVoice: text('robo_voice_not_set', '未设置音色'),
    },
    creation: {
      introTitle: text('robo_ip_creation_slogan', '把你的灵感，变成一套完整的角色IP'),
      introDescription: text('robo_ip_asset_upload_hint', '上传已有的素材资料，或者描述你脑海中的想法，就可以创作出完整的角色IP资产。'),
      createFailure: text('RoboNeo_Web_ip_creation_createFailure', '创建失败，请重试'),
      openFailure: text('RoboNeo_Web_ip_creation_openFailure', '无法打开此角色IP，请检查链接或重试'),
    },
    home: {
      createFallback: text('RoboNeo_Web_ip_creation_createRole'),
      createCard: text('RoboNeo_Web_ip_creation_createRole'),
      createPromotion: text('RoboNeo_Web_ip_creation_createRole'),
      title: text('RoboNeo_Web_ip_list_title'),
      previous: text('RoboNeo_Web_ip_creation_previous', '向左滚动角色IP'),
      next: text('RoboNeo_Web_ip_creation_next', '向右滚动角色IP'),
      promotionDescription: text('RoboNeo_Web_ip_creation_promotionDescription', '属于自己的角色资产'),
      shortDramaTitle: text('RoboNeo_Web_ip_creation_shortDramaTitle'),
      shortDramaDescription: text('RoboNeo_Web_ip_creation_shortDramaDescription'),
      dailyVideoTitle: text('RoboNeo_Web_ip_creation_dailyVideoTitle'),
      dailyVideoDescription: text('RoboNeo_Web_ip_creation_dailyVideoDescription'),
      viralRemakeTitle: text('RoboNeo_Web_ip_creation_viralRemakeTitle'),
      viralRemakeDescription: text('RoboNeo_Web_ip_creation_viralRemakeDescription'),
      stickerTitle: text('RoboNeo_Web_ip_creation_stickerTitle'),
      stickerDescription: text('RoboNeo_Web_ip_creation_stickerDescription'),
      contentTitle: text('RoboNeo_Web_ip_creation_contentTitle'),
    },
    canvas: {
      create: text('RoboNeo_Web_ip_creation_createIp', '创建IP'),
    },
  };
}
